import { configureStore } from '@reduxjs/toolkit';

import slices from './slices';
import services, { middleware } from './services';

export default configureStore({
  reducer: { ...services, ...slices },
  middleware: getMiddleware => getMiddleware().concat(middleware)
});
